export const offsetDays = ( month, direction = 'before' ) => {

    if(direction ===  'before') {
        let offset = new Date(month.split('-')[0], parseInt(month.split('-')[1]-1), 1).getDay();
        let before = ''; // setup blank days before first day of month
        for (var f = 0; f < offset; f++) {
            before += `<div class="day-box offset"><div class="day-box-inner"></div></div>`;
        }
        return before;
    }

    if(direction ===  'after') {
        let totalDays = new Date(month.split('-')[0], parseInt(month.split('-')[1]), 1).getDate();
		let offset = new Date(month.split('-')[0], parseInt(month.split('-')[1]),totalDays).getDay();
        let after = ''; // setup blank days after last day of month
        for (var t = offset; t > 0 && t < 7; t++) {
            after += `<div class="day-box offset"><div class="day-box-inner"></div></div>`;
        }
        return after;
    }

}